import React, { useEffect, useState } from 'react';
import { STATUS } from '../../../../redux/constants';
import {
  Table,
  Button,
  Form,
  Input,
  Checkbox,
  Spin,
  Space,
  Dropdown,
  Menu,
  Tooltip,
  Typography,
} from 'antd';
import Icon, { EditOutlined } from '@ant-design/icons';
import styles from './customers.module.sass';
import back_arrow_icon from '../../../../assets/back_arrow.svg';
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import { ReactComponent as RedDot } from '../../../../assets/icons/Red_dot.svg';
import { ReactComponent as GreenDot } from '../../../../assets/icons/Green_dot.svg';
import { ReactComponent as OrangeDot } from '../../../../assets/icons/Orange_dot.svg';
import history from '../../../../redux/history';
import { ReactComponent as three_dots_icon } from '../../../../assets/icons/ThreeDots.svg';
import { confirmDelete } from '../../../../shared-components/DeleteConfirm';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import SearchUsersComponent from '../SearchUsersComponent';
import { formatEmail } from '../../../../redux/utils/email';

export default function CustomerUsers(props) {
  const params = useParams();
  const formRef = React.createRef();
  const [currentUser, setCurrentUser] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [action, setAction] = useState('list');
  const [company, setCompany] = useState();
  const [isTransferUSerModalOpen, setIsTransferUSerModalOpen] = useState(false);
  const [selectedUserToTranser, setSelectedUserToTranser] = useState(true);

  const { Title } = Typography;

  useEffect(() => {
    props.loadCustomerOrganization(params['uuid']);
    props.loadCustomerOrganizationUsersList(params['id']);
  }, [params['uuid'], currentUser]);

  useEffect(() => {
    if (props.customerOrganizationStatus == STATUS.LOADED) {
      setCompany({
        company_name: props.customerOrganizationData.company_name,
        id: props.customerOrganizationData.id,
        plan_title: props.customerOrganizationData.plan_title,
        subscription: props.customerOrganizationData.subscription,
      });
      props.loadUsersInfoForStaffMember('');
    }
  }, [props.customerOrganizationStatus]);

  const handleAddClick = () => {
    setAction('add');
  };

  const handleTansferClick = () => {
    setIsTransferUSerModalOpen(true);
  };

  const handleEditClick = (currentUser) => {
    setAction('edit');
    setCurrentUser(currentUser);
  };

  const handleBackClick = () => {
    setCurrentUser(null);
    setAction('list');
    window.scrollTo(0, 0);
  };

  const handleBackToOrganisationsClick = () => {
    history.push('/customers');
  };

  const handleSubmit = (values) => {
    if (action == 'edit') {
      props.updateCustomerOrganizationUser(company.id, values.username, values);
      setTimeout(() => {
        handleBackClick();
      }, 1500);
    } else if (action == 'add') {
      props.createCustomerOrganizationUser(company.id, values);
      setTimeout(() => {
        handleBackClick();
      }, 1500);
    }
  };

  const handleChange = (values) => {
    if (values?.email) {
      formRef.current.setFieldsValue({
        email: formatEmail(values.email),
      });
    }
  };

  const handleDeleteClick = (user) => {
    confirmDelete({
      onOk: () => {
        props.deleteCustomerOrganizationUser(company.id, user.username);
      },
    });
  };

  const handleFilter = (inputvalue) => {
    props.loadUsersInfoForStaffMember(inputvalue);
  };

  const handleTranser = () => {
    props.transrUserFromOrgtoAnother(
      selectedUserToTranser,
      props.customerOrganizationData.uuid,
    );
    setIsTransferUSerModalOpen(false);
  };

  const columns = [
    {
      title: <ColumnTitle columnName="Active" />,
      render: (row) =>
        row?.is_active ? (
          !row?.last_login ? (
            <Tooltip title={'no login registered'}>
              <Icon component={OrangeDot} {...props} />
            </Tooltip>
          ) : (
            <Tooltip
              title={`last login: ${moment(row?.last_login).format(
                'YYYY-MM-DD HH:mm',
              )}${row?.is_organization_admin ? ' (organisation admin)' : ''}`}
            >
              <Icon component={GreenDot} {...props} />
            </Tooltip>
          )
        ) : (
          <Tooltip title={'inactive user'}>
            <Icon component={RedDot} {...props} />
          </Tooltip>
        ),
    },
    {
      title: <ColumnTitle columnName="Type" />,
      render: (row) =>
        row?.is_ui_demo
          ? 'Community'
          : row?.is_api_demo
          ? 'API only'
          : 'Regular',
    },
    {
      title: <ColumnTitle columnName="First Name" />,
      dataIndex: 'first_name',
      key: 'first_name',
      align: 'left',
    },
    {
      title: <ColumnTitle columnName="Last Name" />,
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: <ColumnTitle columnName="Email" />,
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: <ColumnTitle columnName="Date Joined" />,
      render: (row) => moment(row?.date_joined).format('YYYY-MM-DD HH:mm'),
    },

    {
      title: <ColumnTitle columnName="Actions" />,
      key: 'actions',
      render: (user) => {
        return (
          <div className={styles.action_buttons}>
            <Space>
              <Button
                type="link"
                onClick={() =>
                  props.inviteCustomerOrganizationUser(
                    company.id,
                    user.username,
                  )
                }
                size="small"
                style={{ padding: 0 }}
              >
                Re-invite
              </Button>
              <EditOutlined onClick={() => handleEditClick(user)} />
              <Dropdown
                trigger={['click']}
                overlay={
                  <Menu className="ant-dropdown-menu">
                    {!user.is_ui_demo && (
                      <Menu.Item
                        className="ant-dropdown-menu-item"
                        onClick={() => {
                          props.addFPsCustomerOrganizationUser(
                            company.id,
                            user.username,
                          );
                        }}
                      >
                        Add pre-defined filter profiles
                      </Menu.Item>
                    )}
                    {user.is_ui_demo && (
                      <>
                        <Menu.Item
                          className="ant-dropdown-menu-item"
                          onClick={() => {
                            props.notifySubscriptionExpiredCustomerOrganizationUser(
                              user.id,
                            );
                          }}
                        >
                          Notify Subscription Expired
                        </Menu.Item>
                      </>
                    )}
                    <Menu.Item
                      className="ant-dropdown-menu-item"
                      onClick={() => handleDeleteClick(user)}
                    >
                      <p style={{ color: 'red' }}>Delete</p>
                    </Menu.Item>
                  </Menu>
                }
              >
                <Icon component={three_dots_icon} />
              </Dropdown>
            </Space>
          </div>
        );
      },
    },
  ];

  const renderListView = () => {
    return (
      <>
        <>
          <Button
            role={'button3'}
            type="primary"
            style={{ borderRadius: '4px', float: 'right', marginBottom: 10 }}
            onClick={() => handleAddClick()}
          >
            Add New User
          </Button>
          <Button
            role={'button3'}
            type="primary"
            style={{
              borderRadius: '4px',
              float: 'right',
              marginBottom: 10,
              marginRight: 10,
            }}
            onClick={() => handleTansferClick()}
          >
            Add Existing User
          </Button>
        </>
        <div className={styles.users}>
          <Table
            pagination={{
              total: props?.customerOrganizationUsersCount,
              current: currentPage,
              pageSize: 20,
              onChange: (current, pageSize) => {
                props.loadCustomerOrganizationUsersListPage(
                  company?.id,
                  current,
                );
                setCurrentPage(current);
              },
            }}
            dataSource={props?.customerOrganizationUsersData}
            columns={columns}
            rowClassName={(record) => {
              return record?.is_organization_admin && styles['org_owner'];
            }}
            style={{ borderTop: '1px solid gray' }}
          />
        </div>
      </>
    );
  };

  const renderDetailView = () => {
    return (
      <div
        style={{
          position: 'relative',
          width: '1000px',
          height: '900px',
          margin: 'auto',
          marginBottom: 20,
          border: '1px solid #ffffff',
        }}
      >
        <Form
          name="user"
          autoComplete="off"
          initialValues={currentUser}
          onFinish={handleSubmit}
          onValuesChange={handleChange}
          ref={formRef}
        >
          <div
            style={{
              position: 'absolute',
              left: '100px',
              color: '#ffffff',
            }}
          >
            <p style={{ marginTop: '10px', marginBottom: '10px' }}>User</p>
            <Form.Item label="First Name" name="first_name">
              <Input />
            </Form.Item>
            <Form.Item label="Last Name" name="last_name">
              <Input />
            </Form.Item>
            <Form.Item label="Email" name="email">
              <Input disabled={action == 'edit' && true} />
            </Form.Item>
            <Form.Item label="Job Description" name="job_description">
              <Input />
            </Form.Item>
            <Form.Item label="Address" name="address" style={{ minWidth: 600 }}>
              <Input />
            </Form.Item>
            <Form.Item label="Phone" name="phone">
              <Input />
            </Form.Item>
            <Form.Item
              label="2FA"
              name="has_2fa_enabled"
              valuePropName="checked"
            >
              <Checkbox checked={currentUser?.has_2fa_enabled} />
            </Form.Item>
            <Form.Item
              label="Organisation Admin"
              name="is_organization_owner"
              valuePropName="checked"
            >
              <Checkbox checked={currentUser?.is_organization_admin} />
            </Form.Item>
            <Form.Item
              label="API Demo User"
              name="is_api_demo"
              valuePropName="checked"
            >
              <Checkbox checked={currentUser?.is_api_demo} />
            </Form.Item>
            <Form.Item
              label="Community User"
              name="is_ui_demo"
              valuePropName="checked"
            >
              <Checkbox checked={currentUser?.is_ui_demo} />
            </Form.Item>
            <Form.Item label="Active" name="is_active" valuePropName="checked">
              <Checkbox checked={currentUser?.is_active} />
            </Form.Item>
            <Form.Item label="username" name="username" hidden></Form.Item>
            <Form.Item
              label="organisation"
              name="organisation"
              initialValue={props.customerOrganizationData.id}
              hidden
            ></Form.Item>
          </div>
          <div style={{ position: 'absolute', top: '780px', left: '400px' }}>
            <Form.Item className={styles.buttons}>
              <Button onClick={() => handleBackClick()}>Cancel</Button>{' '}
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  };

  function render() {
    const isLoading = props.customerOrganizationUsersStatus === STATUS.LOADING;
    const renderSwitch = (action) => {
      switch (action) {
        case 'list':
          return renderListView();
        case 'edit':
        case 'add':
          return renderDetailView();
        default:
          return renderListView();
      }
    };
    return isLoading ? (
      <Spin style={{ margin: 40 }} />
    ) : (
      <>
        <div
          className={styles.back_title}
          onClick={
            action == 'list' ? handleBackToOrganisationsClick : handleBackClick
          }
        >
          <img src={back_arrow_icon} alt="back_arrow" />
          {currentUser ? (
            <Title level={3}>
              {company?.company_name + ' - ' + currentUser?.first_name}
            </Title>
          ) : (
            <Title level={3}>{`${company?.company_name} (${
              company?.plan_title || 'Unsubscribed'
            }) - Users`}</Title>
          )}
        </div>
        {!isLoading ? renderSwitch(action) : renderListView()}
        {
          <SearchUsersComponent
            usersInfoForStaffMember={props?.usersInfoForStaffMember}
            usersInfoForStaffMemberStatus={props?.usersInfoForStaffMemberStatus}
            customerOrganizationData={props.customerOrganizationData}
            isModalOpen={isTransferUSerModalOpen}
            handleTranser={handleTranser}
            setIsTransferUSerModalOpen={setIsTransferUSerModalOpen}
            setSelectedUserToTranser={setSelectedUserToTranser}
            handleFilter={handleFilter}
          />
        }
      </>
    );
  }

  return render();
}
